import firebase from "firebase/app";

import { firebaseRef, db } from "../../config/firebaseInitial";

export const PROFILE_REQUEST = "PROFILE_REQUEST";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_FAILURE = "PROFILE_SUCCESS";

const requestUserProfile = () => {
  return {
    type: PROFILE_REQUEST
  };
};

const receiveUserProfile = userProfile => {
  return {
    type: PROFILE_SUCCESS,
    userProfile
  };
};

const userProfileError = error => {
  return {
    type: PROFILE_FAILURE,
    error
  };
};
export const getUserProfile = () => dispatch => {
  firebaseRef.auth().onAuthStateChanged(user => {
    if (user) {
      let userDoc = db.collection("user").doc(user.uid);
      dispatch(requestUserProfile);
      userDoc
        .get()
        .then(function (doc) {
          if (doc.exists) {
            dispatch(receiveUserProfile(doc.data()));
          } else {
            dispatch(userProfileError("No Profile Found"));
            // doc.data() will be undefined in this case
          }
        })
        .catch(function (error) {
          dispatch(userProfileError(error));
        });
    } else {
      dispatch(userProfileError("No user Loged in"));
    }
  });
};

export const PROFILE_UPDATE_REQUEST = "PROFILE_UPDATE_SUCCESS";
export const PROFILE_UPDATE_FAILURE = "PROFILE_UPDATE_FAILURE";
const requestProfileUpdate = () => {
  return {
    type: PROFILE_UPDATE_REQUEST
  };
};
const ProfileUpdateError = error => {
  return {
    type: PROFILE_UPDATE_FAILURE,
    error
  };
};

export const updateUserProfileNonAuth = updateData => dispatch => {
  let userDoc = db.collection("user").doc(firebase.auth().currentUser.uid);
  dispatch(requestProfileUpdate);
  userDoc
    .update({
      fullName: updateData.fullName,
      phoneNumber: updateData.phoneNumber,
      province: updateData.province,
      city: updateData.city,
      organizationName: updateData.organizationName,
      organizationId: updateData.organizationId
    })
    .then(function () {
      dispatch(getUserProfile()); /// this is so the data will be fetched all over again
    })
    .catch(function (error) {
      dispatch(ProfileUpdateError(error));
    });
};

export const USER_IMAGE_UPDATE_REQUEST = "USER_IMAGE_UPDATE_REQUEST";
export const USER_IMAGE_UPDATE_SUCCESS = "USER_IMAGE_UPDATE_SUCCESS";
export const USER_IMAGE_UPDATE_FAILURE = "USER_IMAGE_UPDATE_FAILURE";

//User Image
const requestUserImageUpdate = () => {
  return {
    type: USER_IMAGE_UPDATE_REQUEST
  };
};
const userImageUpdateError = error => {
  return {
    type: USER_IMAGE_UPDATE_FAILURE,
    error
  };
};

export const updateUserCollectionImgUrl = downloadURL => dispatch => {

  let userDoc = db.collection("user").doc(firebase.auth().currentUser.uid);
  dispatch(requestUserImageUpdate);
  userDoc
    .update({
      imgUrl: downloadURL
    })
    .then(function () {
      dispatch(getUserProfile());
    })
    .catch(function (error) {
      dispatch(userImageUpdateError(error));
    });
};

export const ERASE_USER_STATE = "ERASE_USER_STATE";

export const eraseUserState = () => {
  return {
    type: ERASE_USER_STATE
  };
};
